module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar-default navbar-static-side",
    attrs: {
      "role": "navigation"
    }
  }, [_c('div', {
    staticClass: "sidebar-collapse"
  }, [_c('ul', {
    staticClass: "nav metismenu",
    attrs: {
      "id": "side-menu"
    }
  }, [_vm._m(0), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "fa fa-th-large"
  }), _vm._v(" "), _c('span', {
    staticClass: "nav-label"
  }, [_vm._v("メニュー")])])], 1), _vm._v(" "), _vm._m(1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-header"
  }, [_c('div', {
    staticClass: "dropdown profile-element"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "data-toggle": "dropdown",
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "clear"
  }, [_c('span', {
    staticClass: "block m-t-xs"
  }, [_c('strong', {
    staticClass: "font-bold"
  }, [_vm._v("David Williams")])]), _vm._v(" "), _c('span', {
    staticClass: "text-muted text-xs block"
  }, [_vm._v("Art Director "), _c('b', {
    staticClass: "caret"
  })])])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu animated fadeInRight m-t-xs"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Logout")])])])]), _vm._v(" "), _c('div', {
    staticClass: "logo-element"
  }, [_vm._v("\n          IN+\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "minor.html"
    }
  }, [_c('i', {
    staticClass: "fa fa-th-large"
  }), _vm._v(" "), _c('span', {
    staticClass: "nav-label"
  }, [_vm._v("Minor view")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60eebbf4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Header.vue
// module id = 465
// module chunks = 1